<template>
  <div class="payment-status" v-cloak>
    <div class="iconfont icon-duihao2 bg-color-red" ></div>
    <!--<div class="iconfont icon-iconfontguanbi fail" v-else></div>-->
    <!-- 失败时:订单支付失败 -->

    <div class="status">{{$t('message.user_integral.detail_status_title')}}</div>
    <div class="wrapper">
      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.order.order_no')}}</div>
        <div class="itemCom" v-text="orderInfo.order_id"></div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.order.order_time')}}</div>
        <div class="itemCom" v-text="orderInfo._pay_time"></div>
      </div>

      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.user_integral.pay_points')}}</div>
        <div class="itemCom" v-text="orderInfo.total_integral"></div>
      </div>

    </div>
    <div class="iteminfo">
      {{$t('message.user_integral.detail_status_check_mailbox')}}
    </div>
    <!--失败时: 重新购买 -->
    <div v-if="orderInfo.pay_type == 'weixin' && orderInfo.is_channel == 2">
      <div class="returnBnt bg-color-red" @click="goPages()">View payment results</div>
      <div class="returnBnt cart-color" @click="goPages()">
        Payment failed, please pay again
      </div>
    </div>
    <div v-else>
      <div class="returnBnt bg-color-red" @click="goPages()">{{$t('message.user_integral.detail_status_view_order')}}</div>
      <div class="returnBnt cart-color" @click="goPages('/')">{{$t('message.user_integral.detail_status_back_home')}}</div>
    </div>
  </div>
</template>
<style>
  .iteminfo{
    width: 100%;
    line-height: 0.6rem;
    height: 0.6rem;
    text-align: center;
    color: #666;
    margin-bottom: 0.4rem;
  }
</style>
<script>
import { mapGetters } from "vuex";
import { orderDetail } from "@api/order";
import { detail_integral } from "@api/integral";
import { isWeixin } from "@utils";

const NAME = "PayMentStatus";

export default {
  name: NAME,
  props: {},
  data: function() {
    return {
      id: "",
      status: 0,
      msgContent: "",
      orderInfo: {},
      isWeixin: isWeixin()
    };
  },
  watch: {
    $route(n) {
      if (n.query.msg) this.msgContent = n.query.msg;
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.status = parseInt(n.params.status);
        this.getOrderInfo();
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.id = this.$route.params.id;
    // console.log('orderid=',this.id)
    this.msgContent = this.$route.query.msg;
    this.status = parseInt(this.$route.params.status);
    this.getOrderInfo();
  },
  methods: {
    goPages(route) {
      let routes =
        route !== undefined
          ? route
          : "/order/integral/details/" + this.orderInfo.order_id;
      if (this.status === 5 && route === undefined) routes = "/order/integral/list/1";
      return this.$router.push({
        path: routes
      });
    },
    getOrderInfo() {
      detail_integral(this.id).then(res => {
        // console.log('订单状态',res)
        this.orderInfo = res.data;
        if (this.isWeixin) {
          document.title = this.orderInfo.paid ? "Payment succeeded" : "Payment failed";
        } else {
          document.title = "Order created successfully";
        }
      });
    }
  }
};
</script>
